import { PicklistQueryResponse, unionWithAndFilters } from "../../../../Engine/Core/Picklists/PicklistTypes";
import {
    DigestFilter,
    DigestQueryFilter,
} from "../../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { isNotNullOrUndefined } from "../../../../../../Common/TypingUtils";
import { BasePicklistSearchProps } from "../BasePicklist/BasePicklistProps";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";

import { buildEqualValueFilter, buildSearchFilter } from "./PicklistFilterBuilder";
import {
    FilterBuilder,
    isResolveToAllFilter,
    isResolveToNoneFilter,
    resolveToAllFilter,
    resolveToNoneFilter,
} from "./FilterBuilder";

export const getPickListItemsBySearchQuery = async (
    searchQuery: string,
    picklistProps: BasePicklistSearchProps
): Promise<PicklistQueryResponse> => {
    const { filter, onQueryPicklist, limit, fields } = picklistProps;

    let userFilter: undefined | DigestFilter;
    if (isNotNullOrUndefined(filter)) {
        const userFilterBuilder = filter(new FilterBuilder(), resolveToNoneFilter, resolveToAllFilter);
        if (userFilterBuilder == undefined) {
            userFilter = undefined;
        } else if (isResolveToAllFilter(userFilterBuilder)) {
            userFilter = undefined;
        } else if (isResolveToNoneFilter(userFilterBuilder)) {
            return {
                items: [],
                suitableCount: 0,
                columnMetas: [],
            };
        } else {
            userFilter = userFilterBuilder.build();
        }
    }
    const filterQuery: DigestQueryFilter = {
        filter: unionWithAndFilters(buildSearchFilter(searchQuery, fields), userFilter),
        take: limit,
    };

    const response = await onQueryPicklist(filterQuery);
    return response;
};

export const getPickListItemsByValue = async (
    value: string,
    picklistProps: BasePicklistSearchProps,
    isEnableCaseIndependentValidation?: boolean,
    hasLimit: boolean = true
): Promise<PicklistQueryResponse> => {
    const { onQueryPicklist, searchByField } = picklistProps;
    const limit = hasLimit ? picklistProps.limit : undefined;
    if (isEnableCaseIndependentValidation) {
        const filterQueryInLowerCase: DigestQueryFilter = {
            filter: buildEqualValueFilter(
                isEnableCaseIndependentValidation ? value.toLowerCase() : value,
                searchByField
            ),
            take: limit,
        };
        const filterQueryInUpperCase: DigestQueryFilter = {
            filter: buildEqualValueFilter(
                isEnableCaseIndependentValidation ? value.toUpperCase() : value,
                searchByField
            ),
            take: limit,
        };

        const responseInLowerCase = await onQueryPicklist(filterQueryInLowerCase);
        const responseInUpperCase = await onQueryPicklist(filterQueryInUpperCase);
        return responseInLowerCase.suitableCount > 0 ? responseInLowerCase : responseInUpperCase;
    } else {
        const filterQuery: DigestQueryFilter = {
            filter: buildEqualValueFilter(value, searchByField),
            take: limit,
        };
        return await onQueryPicklist(filterQuery);
    }
};

export interface PicklistControlDependency {
    path: AbsoluteResolvedModelPath;
    field: string;
    value: string;
}
